import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BusyIndicator, Title } from "@ui5/webcomponents-react";
import { AdminApi } from "../../api/client";

function Stat({ value, label, color, onClick }) {
  return (
    <div className="stat-card" style={{ cursor: onClick ? "pointer" : "default" }} onClick={onClick}>
      <div className="value" style={{ color }}>{value}</div>
      <div className="label">{label}</div>
    </div>
  );
}

const RATE_KEY = "calendery_hourly_rate";
const fmtH = (min) => (min / 60).toLocaleString("de-DE", { maximumFractionDigits: 1 });
const fmtEur = (eur) => eur.toLocaleString("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

export default function DashboardPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [rate, setRate] = useState(() => Number(localStorage.getItem(RATE_KEY) || 0));

  useEffect(() => {
    AdminApi.stats().then(setStats).catch(() => {});
  }, []);

  const onRate = (v) => {
    const n = Math.max(0, Number(v) || 0);
    setRate(n);
    localStorage.setItem(RATE_KEY, String(n));
  };

  if (!stats) {
    return <div className="center-screen"><BusyIndicator active size="L" /></div>;
  }

  const monthMin = stats.completed?.thisMonthMinutes ?? 0;
  const allMin = stats.completed?.allTimeMinutes ?? 0;

  return (
    <div>
      <Title level="H2" style={{ margin: "8px 0 16px" }}>Übersicht</Title>
      <div className="stat-grid">
        <Stat value={stats.bookings.upcoming} label="Anstehende Termine" color="#0a6ed1" onClick={() => navigate("/admin/bookings")} />
        <Stat value={stats.bookings.confirmed} label="Bestätigt" color="#107e3e" />
        <Stat value={stats.bookings.pending} label="Offen" color="#e9730c" />
        <Stat value={stats.bookings.cancelled} label="Storniert" color="#aa0808" />
      </div>
      <div className="stat-grid" style={{ marginTop: 14 }}>
        <Stat value={stats.slots.available} label="Freie Slots" color="#0a6ed1" onClick={() => navigate("/admin/slots")} />
        <Stat value={stats.slots.booked} label="Belegte Slots" />
        <Stat value={stats.bookings.total} label="Buchungen gesamt" />
      </div>

      <Title level="H3" style={{ margin: "24px 0 12px" }}>Erteilte Stunden</Title>
      <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "0 0 12px", flexWrap: "wrap" }}>
        <label style={{ fontSize: 13, color: "#4a5867" }}>Stundensatz (€):</label>
        <input className="native-input" type="number" min="0" step="5" value={rate || ""} placeholder="z.B. 60"
          style={{ width: 110 }} onChange={(e) => onRate(e.target.value)} />
        <span className="muted" style={{ fontSize: 12 }}>für die Umsatzschätzung</span>
      </div>
      <div className="stat-grid">
        <Stat value={`${fmtH(monthMin)} h`} label="Diesen Monat" color="#107e3e" />
        <Stat value={`${fmtH(allMin)} h`} label="Gesamt" />
        {rate > 0 && <Stat value={fmtEur((monthMin / 60) * rate)} label="Umsatz (Monat, geschätzt)" color="#107e3e" />}
        {rate > 0 && <Stat value={fmtEur((allMin / 60) * rate)} label="Umsatz (gesamt, geschätzt)" />}
      </div>
    </div>
  );
}
